import axios from "axios";
// import * as dotenv from 'dotenv';
// import { env } from "../env";
// dotenv.config()
// console.log(process.env.NODE_ENV, window._env_.REACT_APP_LIVE_API_URL,window._env_.REACT_APP_DEV_API_URL)
const apiUrl =
  process.env.NODE_ENV === "production"
    ? window._env_.REACT_APP_LIVE_API_URL
    : window._env_.REACT_APP_DEV_API_URL;
// console.log(apiUrl)
var common_axios = axios.create({});

common_axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

common_axios.defaults.baseURL = apiUrl;

common_axios.interceptors.response.use(
  function (response) {
    if (
      localStorage.getItem("token") === "undefined" ||
      response.data.token == "undefined"
    ) {
      // localStorage.clear();
      // window.location.href='/auth-login/';
      // console.log(response)
      window.location.href = `/404`;
    }

    if (response.data.code == 400) {
      // alert("entered here")
      // localStorage.remove("auth");
      // localStorage.remove("session_token");
      // alert("logout")
      // window.location.href=`/logout`;
      // window.location.href='/auth-login/';
    }
    if (response.data.isUpdate === "Y") {
      localStorage.setItem("token", response.data.token);
    }
    return response;
  },
  function (error) {
    if (error.response.status == 404) {
      // console.log(error)
      // alert("logout fkjdskfjkdfk")

      // window.location.href='/';
      window.location.href = `/logout`;
    }
    if (error.response.status == 403) {
      window.location.href = `/logout`;
    }
  }
);

export default common_axios;
